export default "__VITE_ASSET__d8rQJ_aY__"